import { FreelancerAccessErrorTypes } from '../../service/FreelancerAccessError';
import {
    FreelancerCustomersData,
    UpdateActiveProjectData,
    UpdateCustomerRequestData
} from '../../typings/freelancers';

export const FETCH_CUSTOMERS_DATA = 'FETCH_CUSTOMERS_DATA';
export type FETCH_CUSTOMERS_DATA = typeof FETCH_CUSTOMERS_DATA;

export const UPDATE_CUSTOMERS_DATA = 'UPDATE_CUSTOMERS_DATA';
export type UPDATE_CUSTOMERS_DATA = typeof UPDATE_CUSTOMERS_DATA;

export const SHOW_CUSTOMERS_ERROR = 'SHOW_CUSTOMERS_ERROR';
export type SHOW_CUSTOMERS_ERROR = typeof SHOW_CUSTOMERS_ERROR;

export const ACCEPT_CUSTOMER_PROJECT = 'ACCEPT_CUSTOMER_PROJECT';
export type ACCEPT_CUSTOMER_PROJECT = typeof ACCEPT_CUSTOMER_PROJECT;

export const DECLINE_CUSTOMER_REQUEST = 'DECLINE_CUSTOMER_REQUEST';
export type DECLINE_CUSTOMER_REQUEST = typeof DECLINE_CUSTOMER_REQUEST;

export const CLOSE_PROJECT_BY_FREELANCER = 'CLOSE_PROJECT_BY_FREELANCER';
export type CLOSE_PROJECT_BY_FREELANCER = typeof CLOSE_PROJECT_BY_FREELANCER;

export const UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST';
export type UPDATE_CUSTOMER_REQUEST = typeof UPDATE_CUSTOMER_REQUEST;

export const UPDATE_ACTIVE_PROJECT = 'UPDATE_ACTIVE_PROJECT';
export type UPDATE_ACTIVE_PROJECT = typeof UPDATE_ACTIVE_PROJECT;

export const HANDLE_DECLINE_REQUEST_ERROR = 'HANDLE_DECLINE_REQUEST_ERROR';
export type HANDLE_DECLINE_REQUEST_ERROR = typeof HANDLE_DECLINE_REQUEST_ERROR;

export const RELEASE_DECLINE_PROJECT_POPUP = 'RELEASE_DECLINE_PROJECT_POPUP';
export type RELEASE_DECLINE_PROJECT_POPUP = typeof RELEASE_DECLINE_PROJECT_POPUP;

export const OPEN_DECLINE_PROJECT_POPUP = 'OPEN_DECLINE_PROJECT_POPUP';
export type OPEN_DECLINE_PROJECT_POPUP = typeof OPEN_DECLINE_PROJECT_POPUP;

export const CLOSE_DECLINE_PROJECT_POPUP = 'CLOSE_DECLINE_PROJECT_POPUP';
export type CLOSE_DECLINE_PROJECT_POPUP = typeof CLOSE_DECLINE_PROJECT_POPUP;

export interface FetchCustomersDataAction {
    type: FETCH_CUSTOMERS_DATA;
    login: string;
}

export interface UpdateCustomersDataAction {
    type: UPDATE_CUSTOMERS_DATA;
    data: FreelancerCustomersData;
}

export interface ShowCustomersErrorAction {
    type: SHOW_CUSTOMERS_ERROR;
    errorType: FreelancerAccessErrorTypes;
}

export interface AcceptCustomerProjectAction {
    type: ACCEPT_CUSTOMER_PROJECT;
    clientId: string;
    projectId: string;
}

export interface DeclineCustomerRequestAction {
    type: DECLINE_CUSTOMER_REQUEST;
    clientId: string;
    projectId: string;
}

export interface CloseProjectByFreelancerAction {
    type: CLOSE_PROJECT_BY_FREELANCER;
    clientId: string;
    projectId: string;
}

export interface UpdateCustomerRequestAction {
    type: UPDATE_CUSTOMER_REQUEST;
    isAccepted: boolean;
    projectId: string;
    updatedTime: string;
}

export interface UpdateActiveProjectAction {
    type: UPDATE_ACTIVE_PROJECT;
    projectId: string;
    updatedTime: string;
}

export interface HandleDeclineRequestErrorAction {
    type: HANDLE_DECLINE_REQUEST_ERROR;
    clientId: string;
}
export interface ReleaseDeclineProjectPopupAction {
    type: RELEASE_DECLINE_PROJECT_POPUP;
}

export interface OpenDeclineProjectPopupAction {
    type: OPEN_DECLINE_PROJECT_POPUP;
    clientId: string;
    projectId: string;
}
export interface CloseDeclineProjectPopupAction {
    type: CLOSE_DECLINE_PROJECT_POPUP;
}

export function fetchCustomersData(login: string): FetchCustomersDataAction {
    return {
        type: FETCH_CUSTOMERS_DATA,
        login
    };
}

export function updateCustomersData(
    data: FreelancerCustomersData
): UpdateCustomersDataAction {
    return {
        type: UPDATE_CUSTOMERS_DATA,
        data
    };
}

export function showCustomersError(
    errorType: FreelancerAccessErrorTypes
): ShowCustomersErrorAction {
    return {
        type: SHOW_CUSTOMERS_ERROR,
        errorType
    };
}

export function acceptCustomerProject(
    clientId: string,
    projectId: string
): AcceptCustomerProjectAction {
    return {
        type: ACCEPT_CUSTOMER_PROJECT,
        clientId,
        projectId
    };
}

export function updateCustomerRequest(
    data: UpdateCustomerRequestData
): UpdateCustomerRequestAction {
    return {
        type: UPDATE_CUSTOMER_REQUEST,
        ...data
    };
}

export function updateActiveProject(
    data: UpdateActiveProjectData
): UpdateActiveProjectAction {
    return {
        type: UPDATE_ACTIVE_PROJECT,
        ...data
    };
}

export function declineCustomerRequest(
    clientId: string,
    projectId: string
): DeclineCustomerRequestAction {
    return {
        type: DECLINE_CUSTOMER_REQUEST,
        clientId,
        projectId
    };
}

export function closeProjectByFreelancer(
    clientId: string,
    projectId: string
): CloseProjectByFreelancerAction {
    return {
        type: CLOSE_PROJECT_BY_FREELANCER,
        clientId,
        projectId
    };
}

export function handleDeclineRequestError(
    clientId: string
): HandleDeclineRequestErrorAction {
    return {
        type: HANDLE_DECLINE_REQUEST_ERROR,
        clientId
    };
}

export function releaseDeclineProjectPopup(): ReleaseDeclineProjectPopupAction {
    return {
        type: RELEASE_DECLINE_PROJECT_POPUP
    };
}

export function openDeclineProjectPopup(
    clientId: string,
    projectId: string
): OpenDeclineProjectPopupAction {
    return {
        type: OPEN_DECLINE_PROJECT_POPUP,
        clientId,
        projectId
    };
}

export function closeDeclineProjectPopup(): CloseDeclineProjectPopupAction {
    return {
        type: CLOSE_DECLINE_PROJECT_POPUP
    };
}

export type FreelancerCustomersAction =
    | FetchCustomersDataAction
    | UpdateCustomersDataAction
    | ShowCustomersErrorAction
    | AcceptCustomerProjectAction
    | DeclineCustomerRequestAction
    | CloseProjectByFreelancerAction
    | UpdateCustomerRequestAction
    | UpdateActiveProjectAction
    | HandleDeclineRequestErrorAction
    | ReleaseDeclineProjectPopupAction
    | OpenDeclineProjectPopupAction
    | CloseDeclineProjectPopupAction;
